export default __webpack_public_path__ + "static/DSC_3232-ecbb2f2f601c78c8f08e2e79ae6e9ef3.png";